// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".languages {\n  position: relative;\n  margin-left: 6px;\n  display: flex;\n  padding-left: 26px;\n  background-color: var(--color-submain-darken);\n  border-radius: var(--border-radius);\n}\n  @media (max-width: 767px) {.languages {\n    margin-bottom: 10px;\n    width: 100%\n}\n  }\n  .languages__flag {\n    position: absolute;\n    top: 50%;\n    left: 2px;\n    width: 24px;\n    height: 24px;\n    background-size: cover;\n    transform: translateY(-50%);\n  }\n", ""]);
// Exports
module.exports = exports;
